<template>
  <div class="wrap layout">
    <div class="ms-row">
      <div class="col-xs-12 text--center logo-wrap">
        <router-link class="icon-link" to="/">
          <i class="iconfont icon-logo">&#xe673;</i>
        </router-link>
      </div>
      <div class="col-xs-12">
        <img class="error-image" :src="imgPath" alt />
      </div>
      <div class="col-xs-12">
        <h4 class="error-tip">错误页面500</h4>
        <h2 class="error-msg">内部服务器错</h2>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorPageImage from '../assets/imgs/500.png';

export default {
  name: "ErrorPage",
  data() {
    return {
      imgPath: ErrorPageImage
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrap {
    .ms-row { margin: 0; }
    .logo-wrap {
      padding: 1.25rem 0;
      .icon-link { text-decoration: none; }
      .icon-logo { font-size: 2.375rem; color: #000; }
    }
    .error-image { display: block; width: 80%; margin: 2.5rem auto; }
    .error-tip { font-size: 0.8125rem; color: #000; font-weight: 700; line-height: 1; text-align: center; margin-top: 1.25rem; }
    .error-msg { font-size: 1.0625rem; color: #000; font-weight: 400; line-height: 1; text-align: center; margin-top: 0.8125rem; }
  }
  @media screen and (min-width: 48em) {}
  @media screen and (min-width: 64em) {
    .wrap {
      .error-image { width: 410px; margin: 3.75rem auto; }
      .error-tip { font-size: 18px; margin-top: 2.5rem; }
      .error-msg { font-size: 30px; margin-top: 30px; }
    }
  }
  @media screen and (min-width: 75em) {}
</style>